// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__2QqgM","active":"NavItem_active__1clv7","itemIcon":"NavItem_itemIcon__ztumn","itemLabel":"NavItem_itemLabel__3isEU"};